/* Same geometry as the Availability frame (Figma 2161:4787): sidebar 212,
   top bar 50, chip bar 57, content inset 53 from the sidebar and 23 below the
   chips. Pages differ in what they show, never in where the content starts. */
.shell { display: flex; min-height: 100vh; background: var(--bg-page); }

.main { display: flex; flex-direction: column; flex: 1 0 0; min-width: 0; }

.content {
  display: flex;
  flex-direction: column;
  gap: var(--table-gap);
  padding: 23px 0 48px 53px;
}

/* A refetch dims the sections instead of unmounting them, so drilling in never
   blanks the page and reflows it. */
.content[data-fetching='true'] > section {
  opacity: 0.55;
  transition: opacity 120ms ease-out;
}

.notice {
  margin: 0;
  padding: 12px 14px;
  width: var(--table-w);
  max-width: 100%;
  border: 1px solid #e6e2c9;
  border-left: 3px solid #d8b23f;
  border-radius: 8px;
  background: #fffdf4;
  color: #5d5326;
  font-size: 13px;
  line-height: 18px;
}

/* Says why the window on screen is not the window that was asked for. Amber
   rather than red: nothing is broken, the source simply does not go back that
   far, and the reader needs to know before reading the numbers. */
.windowNote {
  display: flex;
  align-items: baseline;
  gap: 10px;
  margin: 0;
  padding: 9px 14px;
  width: var(--table-w);
  max-width: 100%;
  border: 1px solid #e6e2c9;
  border-left: 3px solid #d8b23f;
  border-radius: 8px;
  background: #fffdf4;
  color: #5d5326;
  font-size: 12px;
  line-height: 17px;
}

.windowNote strong {
  flex: none;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}
